import { Col, Row, Spin, Image } from 'antd'
import PromoBox from 'components/PromoBox'
import { StyledPromosWrapper } from '../styles'
import ViewContainer from './container'

export default function Index ({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({ state, promoProducts }) => (
        <Spin spinning={state.promos.status !== 2}>
          <StyledPromosWrapper justify='center' align='middle'>
            <Row gutter={[16, 16]}>
              {(state.promos.status === 2 &&
                state.promos.payload.length > 0) &&
                promoProducts.map((product) => (
                  <Col
                    key={product.id}
                    xs={{ span: 24, offset: 0 }}
                    md={{ span: 24, offset: 0 }}
                    lg={{ span: 12, offset: 0 }}
                  >
                    <PromoBox data={product} mode='small' />
                  </Col>
                ))}
            </Row>
            {(state.promos.status === 2 && state.promos.payload.length === 0) && (
              <Row justify='center' align='middle'>
                <Col style={{ textAlign: 'center' }} span={24}>
                  <Image preview={false} alt='Peri Peri News' src='/images/empty-news.png' />
                  <h2 style={{ color: 'var(--cognac)' }}>We currently don't have promos.</h2>
                </Col>
              </Row>
            )}
          </StyledPromosWrapper>
        </Spin>
      )}
    </ViewContainer>
  )
}
